import {ref} from 'vue';

export default {
    install: (app, options) => {
        const reportYears = ref([]);

        const reportQuarters = ref([
            {value: 1, name: 'Q1 Jan - Mar'},
            {value: 2, name: 'Q2 Apr - Jun'},
            {value: 3, name: 'Q3 Jul - Sep'},
            {value: 4, name: 'Q4 Oct - Dec'},
        ]);

        const reportEmailed = ref([
            {value: true, name: 'Emailed'},
            {value: false, name: 'Not emailed'},
        ]);

        const reportPaid = ref([
            {value: true, name: 'Paid'},
            {value: false, name: 'Not paid'},
        ]);

        const loadCompanyCommissionParametersByCompanyId = (companyId) => {
            window.lazy_axios.get(`/companies/${companyId}/commission/parameters`)
                .then((response) => {
                    if (response.data.years) {
                        reportYears.value = response.data.years;
                    }
                });
        };

        app.provide('reportsCommissionProvider', {
            loadCompanyCommissionParametersByCompanyId,
            reportYears,
            reportQuarters,
            reportEmailed,
            reportPaid,
        });
    },
}
